var React = require('react');
var ReactIntl = require('react-intl');
var injectIntl = ReactIntl.injectIntl;
var IntlProvider = ReactIntl.IntlProvider;
var defaultMessages = require('../../i18n/messages/default');
var AppConstants = require('../../constants/AppConstants');
var PasswordField = require('../Password/PasswordField');
var Header = require('../Header/Header');
var LoginActions = require('../../actions/LoginActions');
var LoginStore = require('../../stores/LoginStore');
var Utils = require('../../utils/Utils.js');
var createReactClass = require('create-react-class');
const { Button } = require("@metro-ui/core");
const FooterMinimal = require('../Footer/FooterMinimal');
require("./reset-password.less");
const passwordPolicies =  window.WebConstants.passwordPolicies || {};
const {uppercase, lowercase, number, specialchars, minlength, maxlength, restrictwhitespaces} = passwordPolicies;
let escapedSpecialChars = specialchars ? specialchars.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : "";
const regexSpecialChar = new RegExp(`[${escapedSpecialChars}]`);

var ResetPassword = createReactClass({
  displayName: 'ResetPassword',
  password: '',

  getInitialState() {
      return {
        requiredChecks:{
          pwdDoesNotContainSpace : 'defaultFieldColor',
          minPasswordLenght :'defaultFieldColor',
          atLeastOneUppercase :'defaultFieldColor',
          atLeastOneLowercase : 'defaultFieldColor',
          atLeastOneNumber : 'defaultFieldColor',
          atLeastOneSpecialChar : 'defaultFieldColor',
        },
          renderPassCriteria : 'passwordValidationBox',
          inValidatePasswordField : true,          
          resetPasswordErrorClass : 'EmailSendError alert alert-danger alert-error',
          localeId : this.props.localeId
      };
  },

  componentDidMount: function () {
    LoginStore.addResetPasswordChangeListener(this._onResetPasswordChange);
  },

  _buildPostPasswordResetRedirectUrl: function(url) {
      let hasQueryParams = url.includes('?') || url.includes('#');
      return url + (hasQueryParams ? '&' : '?') + `emailSent=${AppConstants.EmailSentCode.RESETPASSWORD}`;
  },

  _onResetPasswordChange: function() {
      let appState = LoginStore.getState();
      if (appState.ResetPasswordCode.status === 200) {
        let url = appState.ResetPasswordCode.url;
        let urlSearchParams;
        // if the uri belongs to IDAM then only append the query param to show the toaster message
        if (url && url.indexOf(AppConstants.Links.AUTHORIZE_URL) != -1) {
          // manually append the query param; when using `URLSearchParams`, the query params are losing their encoding
          // which can affect applications relying on a certain format of the url; appending the param manually preserves
          // the redirect url as it would be used by a regular login flow
          url = this._buildPostPasswordResetRedirectUrl(url);
        } 
        window.location.href = url;
      }
      else if (appState.ResetPasswordCode.errorCode === "0201123"){
        LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages["resetPassError0201123"]),"error");
        return
      }
      else if (appState.ResetPasswordCode.url){
        let url = appState.ResetPasswordCode.url;
        let urlSearchParams;
        // if the uri belongs to IDAM then only append the query param to show the toaster message
        if (url.indexOf(AppConstants.Links.AUTHORIZE_URL) != -1) {
          url = this._buildPostPasswordResetRedirectUrl(url);
        }
        window.location.href = url;
      }
      else {
        let url = window.origin + AppConstants.Links.ERROR_PAGE;
        let urlSearchParams = new URLSearchParams(url);
        urlSearchParams.set("error_description", this.props.intl.formatMessage(defaultMessages['resetPasswordError']));
        url = `${decodeURIComponent(urlSearchParams.toString())}`;
        window.location.href = url;
      }
  },

  onLocalChange(localeId) {
    this.setState({ localeId: localeId });
  },

  renderFooter: function () {    
      return (
          <IntlProvider locale = {this.state.localeId}
            messages = {this.props.translations}>
            <FooterMinimal {...this.props} locale = {this.state.localeId} onLocalChange={this.onLocalChange}/>
          </IntlProvider>
        )    
  },
  hideme: function(e) {
      this.setState({resetPasswordErrorClass:'hideMe'})
  },
  onFocusPasswordField: function(e) {
          this.setState({renderPassCriteria:'passwordValidationBox showMe'})
  },

  onPasswordChange: function (password) {
      this.password = password;
      let regexMinLength = new RegExp('^.{'+minlength+','+maxlength+'}$');
      const regexNumber = /[0-9]/;
      const regexLowercase = /[a-z]/;
      const regexWhitespace = /\s/;
      const regexUppercase = /[A-Z]/;

      if(number){
        this.setState(prevState => ({
          requiredChecks: {                   
              ...prevState.requiredChecks,    
              atLeastOneNumber : regexNumber.test(password) ? 'validField' : 'invalidField',     
          }
        }))
      }

      if(lowercase){
        this.setState(prevState => ({
          requiredChecks: {                   
              ...prevState.requiredChecks,    
              atLeastOneLowercase : regexLowercase.test(password) ? 'validField': 'invalidField',     
          }
        }))
      }

      if(uppercase){
        this.setState(prevState => ({
          requiredChecks: {                   
              ...prevState.requiredChecks,    
              atLeastOneUppercase : regexUppercase.test(password) ? 'validField': 'invalidField',    
          }
        }))
      }

      if(specialchars){
        this.setState(prevState => ({
          requiredChecks: {                   
              ...prevState.requiredChecks,    
              atLeastOneSpecialChar : regexSpecialChar.test(password) ? 'validField': 'invalidField',    
          }
        }))
      }

      if(minlength){
        this.setState(prevState => ({
          requiredChecks: {                   
              ...prevState.requiredChecks,    
              minPasswordLenght : regexMinLength.test(password) ? 'validField'  : 'invalidField',    
          }
        }))
      }

      if(restrictwhitespaces){
        this.setState(prevState => ({
          requiredChecks: {                   
              ...prevState.requiredChecks,    
              pwdDoesNotContainSpace :!regexWhitespace.test(password) ? 'validField' : 'invalidField',       
          }
        }))
      }

    let validationArr = [{key1:regexNumber.test(password), key2:number}, {key1:regexLowercase.test(password), key2:lowercase},{key1: regexUppercase.test(password), key2:uppercase},  {key1:regexSpecialChar.test(password),key2:specialchars}, {key1:regexMinLength.test(password), key2:minlength},{key1: !regexWhitespace.test(password), key2: restrictwhitespaces}]
    const enableSubmitButton = (arr) => {
      const filteredFalses = arr.filter(item => item.key2)
      for (let i = 0; i < filteredFalses.length; i++) {
         if (!filteredFalses[i].key1) {
           return false; 
        } 
      }
      return true;
    }

    if(enableSubmitButton(validationArr)){
        this.setState({inValidatePasswordField : false});
      }else{
        this.setState({inValidatePasswordField : true});
      }
  },
  onForgotPasswordSubmit: function (evt) {
    evt.preventDefault();
    LoginActions.submitResetPassword(this.password, this.props);
  },

  renderForm(props) {
        const keysToReplace = {
          '<min>': minlength || "9",
          '<max>': maxlength || "1000",
        };
        const messageNumer = Utils.replaceAllByKeys(
          this.props.intl.formatMessage(defaultMessages['password.validation.minLength']), keysToReplace);
        const messageSpecialChar = this.props.intl.formatMessage(defaultMessages['password.validation.specialChars'])+ " " + specialchars;
        return (
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <form onSubmit={this.onForgotPasswordSubmit}>
                <div className="form-group resetform">
                      <PasswordField {...props}
                          displayStrength={true}
                          onFocus={this.onFocusPasswordField}
                          onPasswordChange={this.onPasswordChange}/>
                      <div className={this.state.renderPassCriteria}>
                          <div className='triangle-container'>
                              <div className='single-triangle'></div>
                          </div>
                          <div className='headingText'>  {this.props.intl.formatMessage(defaultMessages['passwordValidationCriteriaHeader'])} </div>
                            {minlength && <div className={this.state.requiredChecks.minPasswordLenght}>{messageNumer}</div>}
                            {restrictwhitespaces && <div className={this.state.requiredChecks.pwdDoesNotContainSpace}>{this.props.intl.formatMessage(defaultMessages['password.validation.noSpace'])}</div>}
                            {uppercase && <div className={this.state.requiredChecks.atLeastOneUppercase}>{this.props.intl.formatMessage(defaultMessages['password.validation.uppercase'])}</div>}
                            {lowercase && <div className={this.state.requiredChecks.atLeastOneLowercase}>{this.props.intl.formatMessage(defaultMessages['password.validation.lowercase'])}</div>}
                            {number && <div className={this.state.requiredChecks.atLeastOneNumber}>{this.props.intl.formatMessage(defaultMessages['password.validation.number'])}</div>}
                            {specialchars &&<div className={this.state.requiredChecks.atLeastOneSpecialChar}>{messageSpecialChar}</div>}
                          </div>
                            <Button id="submit" type="submit" className="resetform no-margin" style={{ width: "100%" }} kind="primaryRaised" size="large" value="submit" block
                                        isDisabled={this.state.inValidatePasswordField}>
                                {this.props.intl.formatMessage(defaultMessages['submit'])}
                            </Button>
                      </div>
              </form>
              </div>
          );
  },
  render: function () {
    let props = this.props;
    return (
      <div>
          <Header/>
          <div  className="container marginTop">
              <div className="row">
                  <div className="col-lg-3 col-md-3 col-sm-2 col-xs-12"></div>
                  <div className="col-lg-6 col-md-6 col-sm-8 col-xs-12">
                      <div className="resetPasswordContainer">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                 <div className="resetPasswordHeader loginHeader">
                                      <h1> { this.props.intl.formatMessage(defaultMessages['chooseANewPassword'])} </h1>
                                  </div>
                            </div>
                        </div>

                          <hr />
                          <div className="row">
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                  <div className="loginFields">
                                      {this.renderForm(props)}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-2 col-xs-12"> </div>
              </div>

              <div className="push"></div>
          </div>
          {this.renderFooter()}
      </div>
    );
  }
});

module.exports = injectIntl(ResetPassword);
